import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'

export type Candidate = {
  id?: number | null
  address?: string | null
  current_role?: string | null
  email?: string | null
  links?: string[]
  name_ar?: string | null
  name_en?: string | null
  name_i18n?: string | null
  phone_number?: string | null
  nationality_id?: number | null
  country_id?: number | null
  city?: string | null
  cv_file?: {
    filename?: string | null
    data?: string | null
  }
  job_applications_attributes?: { job_id: number | null }
  comments_attributes?: {
    text: string | null
  }
}

export type StateType = {
  candidates: Candidate[]
  fetching: boolean
  resumesFetching: boolean
  candidate_resumes: {
    status: string | 'success'
    error_file_url: string
    message: string
    metadata: {
      success_count: number
      failed_count: number
      total_candidates_count: number
      matched_candidates_count: number
      unmatched_resumes_count: number
    }
  }
}

const initialState: StateType = {
  candidates: [],
  fetching: false,
  resumesFetching: false,
  candidate_resumes: {
    error_file_url: '',
    status: '',
    message: '',
    metadata: {
      success_count: 0,
      failed_count: 0,
      total_candidates_count: 0,
      matched_candidates_count: 0,
      unmatched_resumes_count: 0,
    },
  },
}

export default function reducer(state = initialState, action: Action): StateType {
  // const { payload } = action
  switch (action.type) {
    case actions.RESET_RESUMES_STATUS: {
      return {
        ...state,
        candidate_resumes: { ...initialState.candidate_resumes },
      }
    }
    case actions.ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_PENDING: {
      return {
        ...state,
        resumesFetching: true,
      }
    }

    case actions.CREATE_NEW_CANDIDATE_PENDING:
    case actions.UPDATE_NEW_CANDIDATE_PENDING: {
      return {
        ...state,
        candidate_resumes: {
          ...state.candidate_resumes,
          status: 'pending',
        },
        fetching: true,
      }
    }

    case actions.ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.data,
        candidate_resumes: {
          ...action.payload.data.data?.candidate_resumes,
        },
        resumesFetching: false,
      }
    }

    case actions.CREATE_NEW_CANDIDATE_FULFILLED:
    case actions.UPDATE_NEW_CANDIDATE_FULFILLED: {
      Toastr.success(action.payload.data.data.message)
      return {
        ...state,
        fetching: false,
      }
    }

    case actions.ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        resumesFetching: false,
      }
    }

    case actions.CREATE_NEW_CANDIDATE_REJECTED:
    case actions.UPDATE_NEW_CANDIDATE_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
